<p-dialog
    (onHide)="onHide()"
    (onShow)="onShow()"
    [(visible)]="visible"
    [appendTo]="appendTo"
    [contentStyle]="contentStyle"
    [dismissableMask]="dismissOnClickOutside"
    [draggable]="draggable"
    [minX]="minX"
    [minY]="minY"
    [modal]="blockBackground"
    [style]="autoWidth ? {'width':'auto'} : {}"
>
    <ng-template #header> {{ title | translate }}</ng-template>

    @if (data) { @if (type === 0) { {{data | translate}} } @if (type === 1 || type === 2) {
    <app-code-highlight
        [code]="data | json"
        [language]="type === 1 ? 'csharp' : 'json'"
    />
    } @if (type === 3) {
    <div [innerHTML]="data | translateModel | safeHtml"></div>
    } }
</p-dialog>
